import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PROF_LABEL } from "./JobBoard";

export const REGIONS = ["Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna", "Friuli Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche", "Molise",
  "Piemonte", "Puglia", "Sardegna", "Sicilia", "Toscana", "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto"];
const SELECT = "h-8 rounded-lg border border-emerald-200 bg-white px-2 text-xs text-slate-700";

export function JobAlert() {
  const { user } = useAuth();
  const [a, setA] = useState(null);
  const allowed = user && ["medico", "infermiere"].includes(user.role);
  useEffect(() => {
    if (allowed) api.get("/jobs/alert").then(({ data }) => setA(data)).catch(() => {});
  }, [allowed]);
  if (!allowed || !a) return null;
  const save = (next) => api.put("/jobs/alert", { profession: next.profession, region: next.region, enabled: next.enabled, email: Boolean(next.email) })
    .then(({ data }) => { setA(data); toast.success(data.enabled ? "Avviso attivo: riceverai una notifica per ogni nuova offerta" : "Avviso disattivato"); })
    .catch((e) => toast.error(errMsg(e)));
  const set = (k) => (e) => { const next = { ...a, [k]: e.target.value }; setA(next); if (a.enabled) save(next); };
  return (
    <div className="space-y-2 rounded-2xl border border-emerald-200 bg-emerald-50/90 p-3" data-testid="job-alert">
      <p className="flex items-center gap-2 text-xs font-bold text-emerald-800"><BellRing className="h-4 w-4" />Avvisami delle nuove offerte</p>
      <div className="grid grid-cols-2 gap-2">
        <select data-testid="job-alert-profession" value={a.profession} onChange={set("profession")} className={SELECT}>{Object.entries(PROF_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
        <select data-testid="job-alert-region" value={a.region} onChange={set("region")} className={SELECT}><option value="">Tutte le regioni</option>{REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}</select>
      </div>
      <label className="flex items-center gap-2 text-[11px] text-emerald-900"><input type="checkbox" data-testid="job-alert-email" checked={Boolean(a.email)} onChange={(e) => { const next = { ...a, email: e.target.checked }; setA(next); if (a.enabled) save(next); }} className="accent-emerald-600" />Avvisami anche via email{user.email ? ` (${user.email})` : ""}</label>
      <button data-testid="job-alert-toggle" onClick={() => save({ ...a, enabled: !a.enabled })} className={`w-full rounded-full py-1.5 text-xs font-bold transition-colors ${a.enabled ? "border border-emerald-600 text-emerald-700 hover:bg-white" : "bg-emerald-600 text-white hover:bg-emerald-700"}`}>
        {a.enabled ? "Avviso attivo — disattiva" : "Attiva avviso"}
      </button>
      <Link to="/area-personale?tab=offerte" data-testid="job-saved-link" className="block text-center text-[11px] font-semibold text-emerald-700 hover:underline">Le mie offerte salvate</Link>
    </div>
  );
}
